import React from 'react';

const BlockHeading = (props) => {
    const {title,hrTag} = props;
    return (
        <div >
            <h2 className="text-secondary">{title}</h2>
            <hr className={hrTag ?null:"hr-double-short"} />
        </div>
    );
}
 
export default BlockHeading;